// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs';
import { BrowserTracing } from '@sentry/tracing';
import LogRocket from 'logrocket';

const SENTRY_DSN = process.env.SENTRY_DSN;

Sentry.init({
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
  dsn: SENTRY_DSN,
  tracesSampleRate: 0.05,
  integrations: [
    new BrowserTracing({
      tracingOrigins: ['*'],
    }),
  ],
  environment: process.env.EXECUTION_ENV,
  send_default_pii: true,
});

LogRocket.getSessionURL((sessionURL) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('sessionURL', sessionURL);
  });
});
